import { createCachedSelector } from "re-reselect";

import { getLegAmenityListFromTrip } from "@app/helpers/udm/amenities";

import { getSearch, getTripsSegments } from "../state-accessors";
import { getTripById } from "../trips/get-trip";

export const getLegAmenities = createCachedSelector(
  [getTripById, getTripsSegments, getSearch],
  // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  (trip, segments, search) => getLegAmenityListFromTrip(search, trip, segments)
)((_state, trip_id) => trip_id);
